import $ from 'jquery';

/**
 * Element with `scroll-to` class and `data-target` (selector) attribute.
 */
export default class ScrollTo {
  constructor() {
    $('[data-target].scroll-to').click(function () {
      const $target = $($(this).data('target'));

      if ($target.length) {
        $('html, body').animate({ scrollTop: $target.offset().top }, 1500);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./vively/scripts/components/scroll-to.js